import React, { useState, useEffect } from 'react';
import styled from '@emotion/styled';
import { FiTrash2, FiEdit2, FiChevronDown, FiChevronUp } from 'react-icons/fi';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { FiSearch } from 'react-icons/fi';
import AmenityDetails from './AmenityDetails';
import EditAmenity from './EditAmenity'; 

const ToggleButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  margin-left: 0.5rem;
`;

const Container = styled.div`
  padding: 4rem 2rem;
  margin-bottom: 100px;
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 2rem;

  h2 {
    color: #385963;
  }

  button {
    background-color: #385963;
    color: white;
    border: none;
    padding: 0.5rem 1rem;
    border-radius: 6px;
    cursor: pointer;
    font-size: 0.9rem;
  }

  button:hover {
    background-color: #2c4a52;
  }
     @media (max-width: 768px) {
   h2{
     font-size: 13px;
   }

   button{
      font-size: 10px;
   }

  }
`;

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  background: white;
  box-shadow: 0 4px 10px rgba(0,0,0,0.05);

  th, td {
    padding: 1rem;
    text-align: left;
    border-bottom: 1px solid #eee;
    color: #385963;
  }

  th {
    background-color: #f9f9f9;
  }

  td:last-child {
    text-align: right;
  }

  button {
    background: none;
    border: none;
    color: #e74c3c;
    cursor: pointer;
    font-size: 1.2rem;
  }

  button:hover {
    color: #c0392b;
  }
`;

const SearchBar = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 5rem;
  border: 1px solid #ccc;
  border-radius: 8px;
  padding: 0.5rem 1rem;
  

  input {
    border: none;
    flex: 1;
    font-size: 1rem;
    outline: none;
    color:#385963;
  }

  svg {
    margin-right: 0.5rem;
    color: #555;
  }
`;



const ManageAmenities = () => {

const BASE_URL = process.env.REACT_APP_BASE_URL;
const { i18n, t } = useTranslation();
const tokenString = sessionStorage.getItem("token");
const rawLang = i18n.language;
const language = rawLang.startsWith('gr') ? 'gr' : 'en';
const otherLang = language === 'gr' ? 'en' : 'gr';
const navigate = useNavigate();
const [amenities, setAmenities] = useState([]);
const [expandedRow, setExpandedRow] = useState(null);
const [searchTerm, setSearchTerm] = useState('');

useEffect(() => {
  const fetchAmenities = async () => {
    try {
      // const response = await fetch(`${BASE_URL}Amenity`);

        const requestBody = {
        categoryId: null, // example ID
        providerId: null, // example ID
        status: 1,
         model: {} 
        };

       const response = await fetch(`${BASE_URL}Amenity/search`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${tokenString}`
        },
        body: JSON.stringify(requestBody)
      });

      const data = await response.json();  // <-- THIS is the actual amenities array
      setAmenities(data);
    } catch (error) {
      console.error('Error fetching amenities:', error);
    }
  };

  fetchAmenities();
}, []);

const handleDelete = (id) => {
  if (!window.confirm(t('confirmDelete'))) return;

  // Define the function FIRST
  const deleteAmenity = async () => {
    try {
      const response = await fetch(`${BASE_URL}Amenity/${id}`, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${tokenString}`
        }
      });

      if (!response.ok) {
        const errorMessage = await response.text();
        console.error("Error response:", errorMessage);
        throw new Error(`Failed to delete amenity: ${errorMessage}`);
      }
      // Remove the amenities from state only if deletion succeeded
      setAmenities(prev => prev.filter(d => d.id !== id));

    } catch (error) {
      console.error('Error deleting amenities:', error);
      alert(t('errorDeletingAmenities') || "Cannot delete this amenities. It may be in use.");
    }
  };

  deleteAmenity();
};

const filteredAmenities = Array.isArray(amenities)
  ? amenities.filter((amenities) => {
      const name1 = amenities?.name?.[language]?.toLowerCase() || '';
      const name2 = amenities?.name?.[otherLang]?.toLowerCase() || '';
      const term = searchTerm.toLowerCase();
      return name1.includes(term) || name2.includes(term);
    })
  : [];

const [editingAmenity, setEditingAmenity] = useState(null);  

  const handleEdit = (amenity) => {
    // Open the Edit Form with the selected amenities details
    setEditingAmenity(amenity);
  };

  return (
    <Container>
      <Header>
        <h2>{t('manageAmenities')}</h2>
        <button onClick={() => navigate('/admin/add-amenity')}>
          + {t('addAmenity')}
        </button>
      </Header>

       <SearchBar>
            <FiSearch />
            <input
              type="text"
              placeholder={i18n.t('searchByName')}
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </SearchBar>

      <Table>
        <thead>
          <tr>
            <th>{t('name')}</th>
            <th>{t('actions')}</th>
          </tr>
        </thead>
        <tbody>
          {filteredAmenities.map((amen) => (
            <React.Fragment key={amen.id}>
              <tr>
                {/* <td>{amen.name[language]}</td> */}
                <td>
                  {amen.name[language]}{' '}
                  <span style={{ color: '#888' }}>
                    ({amen.name[otherLang]})
                  </span>
                </td>
                <td style={{ textAlign: 'right' }}>
                  <ToggleButton onClick={() => setExpandedRow(expandedRow === amen.id ? null : amen.id)}>
                    {expandedRow === amen.id ? <FiChevronUp /> : <FiChevronDown />}
                  </ToggleButton>
                  <ToggleButton onClick={() => navigate(`/admin/edit-amenity/${amen.id}`)}>
                    <FiEdit2 />
                  </ToggleButton>
                  <ToggleButton onClick={() => handleDelete(amen.id)}>
                    <FiTrash2 />
                  </ToggleButton>
                </td>
              </tr>
              {expandedRow === amen.id && (
                <tr>
                  <td colSpan="2">
                    <AmenityDetails amenity={amen}  />
                  </td>
                </tr>
              )}
            </React.Fragment>
          ))}
        </tbody>
      </Table>

    </Container>
  );
};

export default ManageAmenities;

